import api from "../api/axiosConfig";
import collectionBanner from "../responses/collectionBanner.json";
import bestSeller from "../responses/bestSellerResponse.json";
import faqs from "../responses/faqs.json";
import VideoBanner from "../responses/videoBanner.json";
import PromoVideoBanner from "../responses/promoVideoBanner.json";
import brandPromise from "../responses/brandPromiseBanner.json";
import blogs from "../responses/blogSection.json";
import mediaTalks from "../responses/mediaTalks.json";

export const getProducts = async () => {
  const response = await api.get("/product");
  return response.data;
};

export const getBestSellerProducts = async () => {
    //const response = await api.get("/bestseller");
    return bestSeller;
};

export const getVideoBanner = async () => {
    //const response = await api.get("/video-banner");
    return VideoBanner;
};

export const getCollectionBanner = async () => {
    //const response = await api.get("/collection-banner");
    return collectionBanner;
};

export const getValueComboProducts = async () => {
    const response = await api.get("/value-combos");
    return response;
};

export const getPromoVideoBanner = async () => {
    //const response = await api.get("/promo-video-banner");
    return PromoVideoBanner;
};

export const getAboutFarmFox = async () => {
    const response = await api.get("/about-farmfox");
    return response;
};

export const getBrandPromiseBanner = async () => {
    //const response = await api.get("/brand-promise-banner");
    return brandPromise;
};

export const getBlogs = async () => {
    //const response = await api.get("/blogs");
    return blogs;
};

export const getBlogsByCategory = async (category) => {
    const response = await api.get(
        `/blogs/category/${category}`
    );
    return response.data;
};

export const getFaqs = async () => {
    //const response = await api.get("/faqs");
    return faqs;
};

export const getRecommendedProducts = async () => {
    const response = await api.get("/recommended-products");
    return response.data;
};

export const getSeoContent = async () => {
    const response = await api.get("/seo-content");
    return response.data;
};

export const getMediaTalks = async () => {
    //const response = await api.get("/media-talks");
    return mediaTalks;
};